import { render, staticRenderFns } from "./x-radio-button.vue?vue&type=template&id=1912ae12&scoped=true&"
import script from "./x-radio-button.vue?vue&type=script&lang=js&"
export * from "./x-radio-button.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-button.vue?vue&type=style&index=0&id=1912ae12&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912ae12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1912ae12', component.options)
    } else {
      api.reload('1912ae12', component.options)
    }
    module.hot.accept("./x-radio-button.vue?vue&type=template&id=1912ae12&scoped=true&", function () {
      api.rerender('1912ae12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-radio-button.vue"
export default component.exports